// extracted by mini-css-extract-plugin
export var carousel = "CreatorsCarousel-module--carousel--7955a";
export var creatorsCarousel = "CreatorsCarousel-module--creatorsCarousel--779af";
export var heading = "CreatorsCarousel-module--heading--06fcc";
export var link = "CreatorsCarousel-module--link--bd7e9";
export var textHeading = "CreatorsCarousel-module--textHeading--9190c";